import React, { useEffect, useState, useRef } from 'react';
import { LoaderRow } from '../../../../mainv3/components/atoms/layout/LoaderRow';

export const useIntersection = (ref, onIntersect) => {
  const [intersecting, setIntersecting] = useState(false);
  const intersectionRef = useRef<boolean>(intersecting);
  useEffect(() => {
    intersectionRef.current = intersecting;
  });

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !intersectionRef.current) {
        onIntersect();
      }
      setIntersecting(entry.isIntersecting);
    });

    observer.observe(ref.current);

    return () => {
      observer.unobserve(ref.current);
    };
  });
};

export const InfiniteScroll = ({ loading, fetchNextPage }) => {
  if (loading) {
    return <LoaderRow />;
  }

  const ref = useRef<HTMLDivElement | null>(null);
  useIntersection(ref, fetchNextPage);

  return (
    <div ref={ref}>
      <LoaderRow />
    </div>
  );
};
